var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", { staticClass: "fs-14 pl-1 fw-700" }, [
        _vm._v("Подтверждающие документы:"),
      ]),
      _c("b-table", {
        staticClass: "table-atmo mb-0",
        attrs: {
          id: "my-table",
          fields: _vm.fields,
          items: _vm.documents,
          small: "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(document)",
            fn: function (data) {
              return [
                _c(
                  "a",
                  {
                    staticClass: "fs-14 col-form-label d-inline-block",
                    staticStyle: { color: "var(--green-color) !important" },
                    attrs: {
                      href: _vm.$getAttachmentDownloadLink(
                        data.item.attachment.file_id
                      ),
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(data.item.attachment.name))]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }